<template lang="pug">
  div
    content-loader(:height="7", v-if="alert.loading")
    div(v-else-if="!showForm")
      h4 We don't have your details yet
      p Update your information to ensure smooth shipping and payment
      b-button.btn-outline(@click="showForm  = true") ADD ADDRESS
    form.mt-3(v-else="", @submit.prevent='onSubmit')
      .row
        .col-md-6
          b-form-group
            label STREET ADDRESS
            b-form-input(type='text', maxlength="60", v-model='inputForm.line_1', required='',  autocomplete="address-line1")
        .col-md-6
          b-form-group
            label.d-inline APARTMENT
            small.d-inline.ml-2 (Name and unit number)
            b-form-input(type='text', minlength="5", maxlength="60", v-model='inputForm.line_2',  autocomplete="address-line2")
        .col-md-6
          b-form-group
            label CITY
            b-form-input(type='text', maxlength="60", v-model='inputForm.city', required='')
        .col-md-6
          b-form-group
            label PROVINCE
            b-form-select(:options="provinces", v-model='inputForm.province', required='')
        .col-md-6
          b-form-group
            label ZIP
            b-form-input(type='number', v-model='inputForm.zip', required='', @keyup="preselectSuburb",  autocomplete="shipping postal-code")
        .col-md-6
          b-form-group
            label.d-inline SUBURB
            small.d-inline.ml-2 (Enter ZIP to find suburbs)
            b-form-select(:options="suburbs", v-model='inputForm.suburb', required='', placeholder='Enter zip first')
            p Your suburb and zip is automatically verified against the national courrier database to ensure smooth deliveries
      .form-group
        button-load(type="submit", :flag="alert.busy", label="SAVE", classes="btn-outline")
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { userService, apiService } from '@/services';
import router from '@/router';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      showForm: false,
      inputForm: {
        line_1: '',
        line_2: '',
        city: '',
        zip: '',
        suburb: '',
      },
      provinces: ['Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 'Mpumalanga', 'Northern Cape', 'North West', 'Western Cape'],
      addresses: [],
    };
  },
  computed: {
    suburbs() {
      const validAddresses = this.addresses.filter(address => address.POSTCODE === this.inputForm.zip);
      const validSuburbs = validAddresses.map(address => address.SUBURB);
      return validSuburbs;
    },
  },
  methods: {
    async onSubmit() {
      try {
        this.busy();
        await userService.updateAddress({ address: this.inputForm, id: this.account.user.customer_id });
        if (this.$route.query.sendmeback) {
          router.push(this.fromUrl);
        } else {
          this.success('Address updated');
        }
      } catch (error) {
        this.error(error);
      }
    },
    preselectSuburb() {
      this.inputForm.suburb = this.suburbs[0];
    },
  },
  async created() {
    try {
      this.loading();
      this.addresses = await apiService.getAddresses();
      const address = await userService.getAddress(this.account.user.customer_id);
      if (address) {
        this.showForm = true;
        this.inputForm = address;
      }
    } catch (error) {
      this.showForm = false;
    }
    this.clear();
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/AccountAddress.vue